export class UpdateStatusRequest {
    status: string ="";
    type: string ="";
    id: string ="";
}